let cache;
if (typeof __TEST__ !== 'undefined' && __TEST__) {
  // Have to use a global during test, as the file-local variable `cache`
  // gets blown away on every file change when watching test files with
  // mocha.
  if (!global.dynamicDataCache) {
    global.dynamicDataCache = new Map();
  }
  cache = global.dynamicDataCache;
} else if (typeof __CLIENT__ !== 'undefined' && __CLIENT__) {
  cache = new Map(window.dynamicData);
  if (cache.size === 0) {
    throw new Error('could not find dynamic data map');
  }
} else {
  cache = new Map();
}

export const makeDynamicDataLoader = (name, fn) => {
  const getter = () => cache.get(name);
  getter.cacheName = name;
  return {
    get: getter,
    load: (...args) => Promise.resolve(cache.has(name) ? cache.get(name) : fn(data => cache.set(name, data), ...args)),
  };
};
